<template lang="pug">
  div.event-views
    media-views
    user-views
</template>

<script>
import MediaViews from './MediaViews'
import UserViews from './UserViews'
export default {
  name: 'EventViews',
  components: {
    MediaViews,
    UserViews
  }
}
</script>

<style lang="scss" scoped>
  .event-views{
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventViews/EventViews.vue